import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { usePlacesState } from '../_load/PlacesLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { usePlaceActionsList } from '../../../../utils/actions/place/list'

const MultiRowsActions = () => {
  const { places } = usePlacesState()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedPlaces = getSelectedData(places)
  const [menuOptions, loading] = usePlaceActionsList(head(selectedPlaces), selecteds)

  return <MultiSelectMenu loading={loading} options={menuOptions} />
}

export default MultiRowsActions
